import React from 'react'
import './style.css'
import { Link } from 'react-router-dom'
import tm1 from '../../images/team/1.png'
import tm2 from '../../images/team/2.png'
import tm3 from '../../images/team/3.png'

const TeamSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className={`volunteer-area section-padding ${props.addclass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="section-title section-title2 text-center">
                            <div className="thumb-text">
                                <span>Our Mentors</span>
                            </div>
                            <h2>The Heart Behind Nardhanamala Foundation</h2>
                            <p>
                                Nardhanamala Foundation thrives because of the passion and dedication of its mentors and volunteers.
                                Our team is committed to nurturing young minds and reviving India’s rich performing arts
                                — from classical dance to soulful music — reaching every child and woman who dreams to learn.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="volunteer-wrap">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm1} alt="Dance Instructor" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Rekha Ramachandran </Link></h2>
                                    <span>Managing Director of NARDHANAMALA CENTRE FOR PERFORMING ARTS FOUNDATION
                                        Dance Exponent</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm3} alt="Children Arts Trainer" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Prof. Dr.JayaRajini</Link></h2>
                                    <span>Vision Scientist
                                        Independent Entrrpreneur& Wellness Consultant</span>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm2} alt="Music Mentor" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Rakhesha Dhiwakar </Link></h2>
                                    <span>Physiotherapist & Dance Exponent</span>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm4} alt="Community Program Lead" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Lakshmi Devi</Link></h2>
                                    <span>Rural & Women’s Program Lead</span>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeamSection
